import {
  JobsConfigurationCommand,
  JobsConfigurationJob
} from "modules/system/sections/plt/field-management/rings/rollout-package/configure/jobs/dtos";

import { FontIcon, ShimmeredDetailsListProps, useTheme } from "@bps/fluent-ui";
import { DataTable, DataTableColumn } from "@components/tables/DataTable";

import { CommandDeleteButton } from "./CommandDeleteButton";
import { CommandEditButton } from "./CommandEditButton";

interface CommandsProps extends ShimmeredDetailsListProps {
  job: JobsConfigurationJob;
}

export const CommandsTable = ({ job, ...props }: CommandsProps) => {
  const theme = useTheme();

  const columns: DataTableColumn<JobsConfigurationCommand>[] = [
    {
      key: "code",
      name: "Code",
      minWidth: 150,
      maxWidth: 300,
      isResizable: true,
      isSorted: true,
      sort: true,
      onRender: (command: JobsConfigurationCommand) => command.code
    },
    {
      key: "commandName",
      name: "Command Name",
      minWidth: 150,
      isResizable: true,
      onRender: (command: JobsConfigurationCommand) => command.commandName
    },
    {
      key: "runOnStart",
      name: "Run on start?",
      minWidth: 150,
      isResizable: true,
      onRender: (command: JobsConfigurationCommand) =>
        !!command.runOnStart ? (
          <FontIcon
            iconName="CompletedSolid"
            styles={{
              root: {
                color: theme.palette.green,
                fontSize: 16
              }
            }}
          />
        ) : (
          <FontIcon
            iconName="StatusErrorFull"
            styles={{
              root: {
                color: theme.palette.red,
                fontSize: 16
              }
            }}
          />
        )
    },
    {
      key: "uploadFrequency",
      name: "Upload Frequency",
      minWidth: 150,
      isResizable: true,
      onRender: (command: JobsConfigurationCommand) => command.uploadFrequency
    },
    {
      key: "uploadWindow",
      name: "Upload Window",
      minWidth: 150,
      isResizable: true,
      onRender: (command: JobsConfigurationCommand) => command.uploadWindow
    },
    {
      key: "edit",
      name: "",
      minWidth: 30,
      maxWidth: 30,
      onRender: (command: JobsConfigurationCommand) => (
        <CommandEditButton job={job} command={command} />
      ),
      sort: false
    },
    {
      key: "delete",
      name: "",
      minWidth: 30,
      maxWidth: 30,
      onRender: (command: JobsConfigurationCommand) => (
        <CommandDeleteButton job={job} command={command} />
      ),
      sort: false
    }
  ];

  return (
    <DataTable
      stickyHeader
      shimmerLines={10}
      columns={columns}
      onShouldVirtualize={() => false}
      {...props}
    />
  );
};
